import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../../api/$api";
import { TDataToken, TQueries } from "./type";

// get all users of a cohort of an org
export const getOrgCohortDetails = (
    data: TDataToken,
    payload: TQueries
) => {
    return $api
        .post("/admin/orgs/cohorts/get-details", { ...payload }, { token: data.accessToken })
        .then((response) => {
            return response?.payload?.data;
        });
};

export const useOrgCohortDetailsSA = (data: TDataToken, queries: TQueries, config?: {}) => {
    return useQuery({
        queryKey: ["orgCohortDetails", queries],
        queryFn: () => getOrgCohortDetails(data, queries),
        ...config as UseQueryOptions<any>
    });
};


// get all users of a cohort of an org
export const getOrgCohortUserDetails = (
    data: TDataToken,
    payload: TQueries
) => {
    return $api
        .get("admin/groups/cohort-users", { token: data.accessToken, params: { ...payload } })
        .then((response) => {
            return response;
        });
};

export const useOrgCohortUserDetailsSA = (data: TDataToken, queries: TQueries, config?: {}) => {
    return useQuery({
        queryKey: ["orgCohortUsertDetails", queries],
        queryFn: () => getOrgCohortUserDetails(data, queries),
        ...config as UseQueryOptions<any>
    });
};
